import { Dropdown } from './dropdown.model';

export class DropdownList {
  public items: Dropdown[] = []; // list of dropdown items
  public data: string; // tells us what type of data our dropdown contains reference to
}
